import React from 'react'
import { Row, Col} from 'antd'
import CardTotalCost from '../Cards/card-total-cost'
import CardStorageUsage from '../Cards/card-storage-usage'
import CardBucketCount from '../Cards/card-bucket-count'
import SupportChart from './support-chart'
import './support.scss'


export default ({selectedAccount, supportChartData, totalCost}) => (
    <div>
    <div>
        <Row type="flex" gutter={30} className="overview-container">
        <Col span={6}>
                <Row type="flex" className="rowStyle">
                    <Col span={24}>
                        <CardTotalCost title="Total AWS Support Cost" totalCost={totalCost} />
                    </Col>
                </Row>
                <Row className="rowStyle">
                    <Col span={24}>
                        <CardStorageUsage storageUsage={selectedAccount.total_bytes_used} />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <CardBucketCount bucketCount={selectedAccount.bucket_count} />
                    </Col>
                </Row>
            </Col>

            <Col span={18}>
                <div className="overview-chart-container">
                   <SupportChart supportChartData={supportChartData} /> 
                </div>
            </Col>
        </Row>
    </div>

    </div>
)